export default {
  state: {
    new: null,
    message: []
  },
  getters: {
    doneTodos: state => {
      return state.message.filter(todo => todo.done);
    }
  }
};
